import LeadListView from './LeadListView';

export default LeadListView;
